
/*
$(function() {
  return $('select').select2();
});
*/

$(function() {
  return $('.toggle-checkbox').bootstrapSwitch({
    size: "small"
  });
});



/*
$(function() {
  return $('.match-height').matchHeight();
});
*/

/*
$(function() {
  return $('.datatable').DataTable({
    "dom": '<"top"fl<"clear">>rt<"bottom"ip<"clear">>'
  });
});
*/

// $(function() {
//   return $(".side-menu .nav .dropdown").on('show.bs.collapse', function() {
//     return $(".side-menu .nav .dropdown .collapse").collapse('hide');
//   });
// });

// function eraseCookie(name) {
//     createCookie(name,"",-1);
// }
//
//
//
// (function ($) {
//     var _original = $.fn.modal.Constructor.prototype.hide;
//
//     function trigger(target, name, relatedTarget) {
//         target.trigger($.Event(name, { relatedTarget: relatedTarget }));
//     }
//
//     $.extend($.fn.modal.Constructor.prototype, {
//         hide: function (_relatedTarget) {
//             if (this.isLocked) return;
//             if(($(".modal").data('bs.modal') || {isShown: false}).isShown){
//                 $('body').addClass('modal-opened');
//             }else{
//                 $('body').removeClass('modal-opened');
//             }
//             return _original.call(this, _relatedTarget);
//         },
//
//         lock: function (_relatedTarget) {
//             this.isLocked = true;
//             trigger(this.$element, 'lock.bs.modal', _relatedTarget);
//         },
//
//         unlock: function (_relatedTarget) {
//             this.isLocked = false;
//             trigger(this.$element, 'unlock.bs.modal', _relatedTarget);
//         }
//     });
// })(jQuery);